"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable react/prop-types */


var goBackAfterSuccess = function goBackAfterSuccess(WrappedComponent) {
  return function (props) {
    props.submitSucceeded && props.history.goBack();
    return _react.default.createElement(WrappedComponent, props);
  };
};

var _default = goBackAfterSuccess;
exports.default = _default;